import { NavigateFunction } from "react-router-dom";
import { Hit } from "../../../../data-model/algoliaSearchModel";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { isBlockedMedicalOrderStatus } from "../../../../utils/isInvalidMedicalOrderStatus";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";

/**
 * Navigates from a My PA Orders row to the EV/BV detail screen and logs the click event.
 * No-ops when the order is in development (empty status) or agent-in-progress.
 *
 * @param rowData - Table row payload containing `id` and serialized `rowData`
 * @param userId - Authenticated user id for analytics
 * @param userEmail - Authenticated user email for analytics
 * @param tabId - Worklist tab identifier used as the analytics source
 * @param navigate - React Router navigate function
 */
export const handleNavigateToNextScreenFromMyPaTable = (
  rowData: any,
  userId: string,
  userEmail: string,
  tabId: string,
  navigate: NavigateFunction,
) => {
  const data = JSON.parse(rowData.rowData as string) as Hit;
  // Block navigation while the order is still being prepared or handled by an agent.
  if (isBlockedMedicalOrderStatus(data?.medical_order_status)) {
    return;
  }
  apiWorkerManager.enqueueAndProcess({
    patient_id: data?.patient_id ?? "",
    org_id: getOrgIdForFetchExternalWorklist(),
    order_id: rowData.id,
    event_name: EventsName.ORDER_CLICKED,
    user_id: userId ?? "",
    user_email: userEmail ?? "",
    additional_data: {
      screen_name: ScreenNamesForBigQuery.WORKLIST,
      source: tabId ?? "",
    },
  });
  navigate(`/worklists/evbv/${rowData["id"]}`);
};
